/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Generationcount1Inputs */

const zh_analytics_generationcount1 = /** @type {(inputs: Analytics_Generationcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 生成次数`)
};

const en_analytics_generationcount1 = /** @type {(inputs: Analytics_Generationcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generations`)
};

const es_analytics_generationcount1 = /** @type {(inputs: Analytics_Generationcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generaciones IA`)
};

/**
* | output |
* | --- |
* | "AI Generations" |
*
* @param {Analytics_Generationcount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_generationcount1 = /** @type {((inputs?: Analytics_Generationcount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Generationcount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_generationcount1(inputs)
	if (locale === "en") return en_analytics_generationcount1(inputs)
	return es_analytics_generationcount1(inputs)
});
export { analytics_generationcount1 as "analytics_generationCount" }